<app-feature-list-container
  *ngIf="refrigerantCircuitStatistics$ | async | ready as statistics"
  [title]="title"
>
  <div class="feature-grid-container" viFeatureGrid viBorderBottom>
    <app-feature-list-item
      [error]="statistics | error"
      [label]="
        ('+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.HOURS_CLASS_ONE.LABEL' | translate) + ':'
      "
      [value]="statistics?.properties?.hoursLoadClassOne?.value | toFixed: 0 | suffix: SUFFIX.hour"
      [attr.data-feature]="statistics.feature + '/hoursLoadClassOne'"
    >
    </app-feature-list-item>
    <app-feature-list-item
      [error]="statistics | error"
      [label]="
        ('+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.HOURS_CLASS_TWO.LABEL' | translate) + ':'
      "
      [value]="statistics?.properties?.hoursLoadClassTwo?.value | toFixed: 0 | suffix: SUFFIX.hour"
      [attr.data-feature]="statistics.feature + '/hoursLoadClassTwo'"
    >
    </app-feature-list-item>
    <app-feature-list-item
      [error]="statistics | error"
      [label]="
        ('+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.HOURS_CLASS_THREE.LABEL' | translate) +
        ':'
      "
      [value]="
        statistics?.properties?.hoursLoadClassThree?.value | toFixed: 0 | suffix: SUFFIX.hour
      "
      [attr.data-feature]="statistics.feature + '/hoursLoadClassThree'"
    >
    </app-feature-list-item>
    <app-feature-list-item
      [error]="statistics | error"
      [label]="
        ('+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.HOURS_CLASS_FOUR.LABEL' | translate) + ':'
      "
      [value]="statistics?.properties?.hoursLoadClassFour?.value | toFixed: 0 | suffix: SUFFIX.hour"
      [attr.data-feature]="statistics.feature + '/hoursLoadClassFour'"
    >
    </app-feature-list-item>
    <app-feature-list-item
      [error]="statistics | error"
      [label]="
        ('+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT.HOURS_CLASS_FIVE.LABEL' | translate) + ':'
      "
      [value]="statistics?.properties?.hoursLoadClassFive?.value | toFixed: 0 | suffix: SUFFIX.hour"
      [attr.data-feature]="statistics.feature + '/hoursLoadClassFive'"
    >
    </app-feature-list-item>
  </div>
</app-feature-list-container>
